import { render, staticRenderFns } from "./settlement-item-table.vue?vue&type=template&id=459cfbdf&scoped=true&"
import script from "./settlement-item-table.vue?vue&type=script&lang=js&"
export * from "./settlement-item-table.vue?vue&type=script&lang=js&"
import style0 from "./settlement-item-table.vue?vue&type=style&index=0&id=459cfbdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459cfbdf",
  null
  
)

export default component.exports